import { RevalueType } from '@/pages/tools/RevaluationTool/types';

/** Most-recent runs to request from the listing endpoint (poll + stream). */
export const TASK_POLL_LIMIT = 25;

export const REVALUE_TYPE_LABELS: Record<string, string> = {
  [RevalueType.VALUE_AND_METRICS]: 'Valuation',
  [RevalueType.BCVA]: 'BCVA',
};

export const revalueTypeLabel = (type: string): string =>
  REVALUE_TYPE_LABELS[type] ?? type;

// Statuses the backend treats as terminal: the job is no longer in flight.
// `unknown` is the backend's "no longer tracked / failed" terminal state.
export const TERMINAL_TASK_STATUSES = ['finished', 'unknown'];

export const isTaskTerminal = (status?: string): boolean =>
  TERMINAL_TASK_STATUSES.includes((status ?? '').toLowerCase());

export const isTaskActive = (task: { status: string }): boolean =>
  !isTaskTerminal(task.status);
